import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['valueInput', 'unitSelect'];

  connect() {
    this.previousUnit = this.element.dataset.previousUnit || this.unitSelectTarget.value;
  }

  changeUnit(event) {
    const newUnit = this.unitSelectTarget.value;
    const fromUnit = this.previousUnit;
    const rawValue = this.valueInputTarget.value;

    if (!rawValue || !fromUnit || fromUnit === newUnit) {
      this.previousUnit = newUnit;
      return;
    }

    const params = new URLSearchParams({ value: rawValue, from: fromUnit, to: newUnit });

    fetch(`/units/convert?${params.toString()}`, {
      headers: { 'Accept': 'application/json' }
    })
      .then(response => {
        if (!response.ok) throw new Error('convert failed');
        return response.json();
      })
      .then(data => {
        this.valueInputTarget.value = data.value;
        this.previousUnit = newUnit;
      })
      .catch(() => {
        // Revert the unit selection on failure so we don't silently corrupt data
        this.unitSelectTarget.value = fromUnit;
        if (window.toastr) {
          window.toastr.error('Unable to convert value between units.');
        }
      });
  }
}
